// extracted by mini-css-extract-plugin
module.exports =  {"seller-details":"gNzFTxL","sellerDetails":"gNzFTxL","seller-name":"qbZiuNw","sellerName":"qbZiuNw","badge":"SWfzprc","promoted-gig-text":"U_b1vQC","promotedGigText":"U_b1vQC"};